
export const LOCAL_STORAGE = {
         GET: ({ key }) => {
           const data = localStorage.getItem(key);
           if (data) {
             return JSON.parse(data);
        }
             return null
         },

         SET: ({ key, value }) => {
           const result = JSON.stringify(value);
           localStorage.setItem(key, result);
         },

         REMOVE: ({ key }) => localStorage.removeItem(key),

         CLEAR: ({ key }) => localStorage.clear(),
};
